import AppRoot from "@app-root";
import { withLDProvider } from "launchdarkly-react-client-sdk";
import { PropsWithChildren } from "react";
import { BrowserRouter, HashRouter } from "react-router-dom";
import DebugBanner from "./DebugBanner";
import { isDeployPreview, VITE_LD_CLIENT_ID } from "./env";
import PortalRoot from "./PortalRoot";

function Router({ children }: PropsWithChildren) {
  if (isDeployPreview) {
    return <HashRouter>{children}</HashRouter>;
  }
  return <BrowserRouter>{children}</BrowserRouter>;
}

function AppWrapper() {
  return (
    <Router>
      <PortalRoot />
      <DebugBanner />
      <AppRoot />
    </Router>
  );
}

export default withLDProvider({
  clientSideID: VITE_LD_CLIENT_ID,
  // initialize app with anonymous user context to prevent blowing through our LD Monthly Active User limit
  context: {
    kind: "user",
    key: "uninitialized-user",
    anonymous: true,
  },
})(AppWrapper);
